import { render, staticRenderFns } from "./AuditLogSetupListing.vue?vue&type=template&id=e989061e&"
import script from "./AuditLogSetupListing.vue?vue&type=script&lang=js&"
export * from "./AuditLogSetupListing.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogSetupListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports